import { PASSWORD } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Form, Input } from 'antd';
const rules = [
    {
        max: PASSWORD.MAX_LENGTH,
        message: PASSWORD.REQUIRED_MESSAGE_CURRENT,
        min: PASSWORD.MIN_LENGTH,
        pattern: PASSWORD.PATTERN,
        required: true,
        type: 'string'
    }
];
export const CurrentPassword = ({ disabled, id, name = 'currentPassword' }) => React.createElement(Form.Item, { id: id, name: name, rules: rules },
    React.createElement(Input.Password, { disabled: disabled, placeholder: PASSWORD.PLACEHOLDER_CURRENT, type: 'text' }));
